import React from "react";
import PropTypes from "prop-types";
import MarkerRange from "./markerRange";
import MarkerDetails from "./markerDetails";
import { Button } from "cxa-components";
import { loadDetails } from "actions/advancedScreeningResultsActions";
import { connect } from "react-redux";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import _ from "lodash";

class Marker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
    };
  }

  static propTypes = {
    marker: PropTypes.object.isRequired,
    basic: PropTypes.bool,
    hasDetails: PropTypes.bool,
    loadDetails: PropTypes.func,
    details: PropTypes.object,
    detailsFetching: PropTypes.object,
    intl: intlShape.isRequired,
  };

  handleLoad = () => {
    const { marker, basic, loadDetails } = this.props;

    if (!basic) {
      loadDetails(marker.tag);
    }
  };

  onClick = e => {
    e.preventDefault();

    const { marker, basic, details } = this.props;

    if (!this.state.showDetails && !(basic || details[marker.tag])) {
      this.handleLoad();
    }

    this.setState({ showDetails: !this.state.showDetails });
  };

  render() {
    const { showDetails } = this.state;
    const {
      marker,
      detailsFetching,
      basic,
      details,
      hasDetails,
      intl,
    } = this.props;
    const loading = !basic && detailsFetching[marker.tag];

    const {
      status,
      value,
      unit,
      description,
      name,
      ranges,
      rangeValue,
    } = marker;
    const descriptionIntl =
      description &&
      !_.isEmpty(description) &&
      intl.formatMessage({ id: description, defaultMessage: description });
    const unitIntl =
      unit && !_.isEmpty(unit)
        ? intl.formatMessage({ id: unit, defaultMessage: unit })
        : null;

    const descriptionText =
      descriptionIntl && unit //eslint-disable-line no-nested-ternary
        ? `${descriptionIntl} (${unitIntl})`
        : descriptionIntl //eslint-disable-line no-nested-ternary
          ? descriptionIntl
          : unitIntl ? `(${unitIntl})` : null;

    const markerDetails = basic ? null : details[marker.tag];
    const hasRange = ranges && rangeValue;

    let markerClass = "apl-marker";
    if (hasRange) {
      markerClass = markerClass + " apl-marker--range";
    }

    const showDetailsTextPrefix = showDetails
      ? intl.formatMessage(messages.fewerTextDescription)
      : intl.formatMessage(messages.moreTextDescription);
    return (
      <div className={markerClass}>
        <div className="apl-marker__description" data-has-details={hasDetails}>
          <h4>
            {name && !_.isEmpty(name)
              ? intl.formatMessage({ id: name, defaultMessage: name })
              : ""}
          </h4>
          {descriptionText && <p>{descriptionText}</p>}
        </div>
        {hasRange && <MarkerRange data={marker} />}
        <p className={`apl-marker__score apl-marker__score--${status}`}>
          {value}
        </p>
        {hasDetails && (
          <p className="apl-marker__toggle">
            <Button
              type="button"
              submitting={loading}
              onClick={this.onClick}
              title={`${showDetailsTextPrefix} ${intl.formatMessage(
                messages.detailsTextDescription
              )}`}
            >
              {showDetails ? "-" : "+"}
            </Button>
          </p>
        )}
        {showDetails &&
          !loading && (
            <div className="apl-marker__details">
              <MarkerDetails
                marker={marker}
                basic={basic}
                details={markerDetails}
              />
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = (store, ownProps) => {
  const { advancedScreeningResults: { details, detailsFetching } } = store;
  const { basic } = ownProps;

  return basic
    ? {}
    : {
        details,
        detailsFetching,
      };
};

const mapDispatchToProps = {
  loadDetails,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(Marker));



// WEBPACK FOOTER //
// ./components/employee/wellness/marker.jsx